<script lang="tsx" setup>
import { getCurrentInstance } from "vue"

import SVG_Logo from "../SVGs/SVG_Logo.vue"
import { letterforms } from "@/data/letterforms"
import SVG_Letterform from "../SVG_Letterform.vue"

const { appContext } = getCurrentInstance()!
const footerLinks: { id: string; url: string; title: string }[] =
  appContext.config.globalProperties.$site.footerLinks
</script>

<template>
  <footer class="relative z-20 overflow-hidden mt-8 border-t">
    <!-- <div class="flex lg:flex-row flex-col w-full">
      <div class="flex-1 min-h-0 bg-[#0057BB]">
        <div class="h-full p-4">
          <SVG_Letterform
            :masters="letterforms.c"
            :min-gap-scale="{ default: 4 }"
            :stroke-width="1"
            stroke="black"
            class="fill-[#9C883A]"
          />
        </div>
      </div>

      <div class="flex-1 min-h-0">
        <div class="h-full p-4 bg-[#9C883A]">
          <SVG_Letterform
            :masters="letterforms.m"
            :min-gap-scale="{ default: 4 }"
            :stroke-width="1"
            stroke="black"
            class="fill-[#0057BB]"
          />
        </div>
      </div>
    </div> -->
    <div class="p-4 py-8">
      <div class="grid lg:grid-cols-4 gap-linebreak items-center">
        <div class="col-span-2">
          <div class="flex flex-row items-center">
            <a
              href="https://www.aaschool.ac.uk/"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center pointer-events-auto link"
            >
              <SVG_Logo class="w-12 lg:w-18" />
              <div class="pl-4 leading-tight text-sm">
                Architectural Association<br />
                School of Architecture
              </div>
            </a>
          </div>
        </div>
        <div class="col-span-2 columns-2 text-sm">
          <div v-for="{ url, title, id } in footerLinks" class="block">
            <a
              class="link"
              :href="url"
              target="_blank"
              rel="noopener noreferrer"
              :key="id"
            >
              {{ title }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
